import { Typography, Grid2 as Grid } from '@mui/material'

/**
 * Componente que exibe as legendas do gráfico de ECG
 * Mostra o significado das cores (vermelho = alteração, verde = normal)
 */
export const ECGLegend = () => {
  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid size={12}>
        <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
          Legendas:
        </Typography>
        <Typography variant='body2' sx={{ ml: 2 }}>
          <span style={{ color: 'red' }}>■</span> Compatível com alteração
        </Typography>
        <Typography variant='body2' sx={{ ml: 2 }}>
          <span style={{ color: 'green' }}>■</span> Sem alteração
        </Typography>
      </Grid>
    </Grid>
  )
}
